(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-store"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.nav-tabs .tab-title').forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      document.querySelectorAll('.nav-tabs .tab-title').forEach(function(t) {
        t.classList.remove('active', 'show');
      });
      
      this.classList.add('active', 'show');
      
      document.querySelectorAll('.tab-pane').forEach(function(pane) {
        pane.classList.remove('active', 'show');
      });
      
      const target = this.getAttribute('href');
      document.querySelector(target).classList.add('active', 'show');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.setupHoverMenu();
    }
    
    setupHoverMenu() {
      const menuItems = this.querySelectorAll('.header__menu-item');
      menuItems.forEach(item => {
        item.addEventListener('mouseenter', this.showSubmenu);
        item.addEventListener('mouseleave', this.hideSubmenu);
      });
    }
  
    showSubmenu(event) {
      const submenu = event.target.querySelector('.header__submenu');
      if (submenu) {
        submenu.classList.add('header__submenu--visible');
      }
    }
  
    hideSubmenu(event) {
      const submenu = event.target.querySelector('.header__submenu');
      if (submenu) {
        submenu.classList.remove('header__submenu--visible');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-left-text"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Función para verificar si un elemento está en el viewport
  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  };

  // Función principal de revelación con debugging
  const reveal = () => {
    const reveals = document.querySelectorAll(".reveal");
    console.log(`Found ${reveals.length} elements with 'reveal' class`); // Debugging

    reveals.forEach((element, index) => {
      try {
        // Verificar si el elemento tiene imagen de fondo
        const hasBackgroundImage = window.getComputedStyle(element).backgroundImage !== 'none';
        
        if (hasBackgroundImage) {
          // Si tiene imagen de fondo, esperar a que se cargue
          const imageUrl = window.getComputedStyle(element).backgroundImage.slice(4, -1).replace(/['"]/g, '');
          const img = new Image();
          
          img.onload = () => {
            console.log(`Background image loaded for element ${index}`); // Debugging
            if (isInViewport(element)) {
              element.classList.add("active");
            }
          };
          
          img.src = imageUrl;
        } else {
          // Si no tiene imagen de fondo, revelar basado en viewport
          if (isInViewport(element)) {
            element.classList.add("active");
          }
        }
      } catch (error) {
        console.error(`Error processing reveal element ${index}:`, error);
      }
    });
  };

  // Optimización del evento scroll con throttling
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(() => {
        reveal();
        scrollTimeout = null;
      }, 100); // Throttle a 100ms
    }
  });

  // Observador de mutaciones para manejar cambios dinámicos
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        reveal();
      }
    });
  });

  // Configurar el observador
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Llamada inicial
  reveal();

  // Manejar carga de imágenes
  window.addEventListener('load', reveal);
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-right-text"] && !window.DesignMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
  function reveal() {
    var reveals = document.querySelectorAll(".reveal");

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var containerHeight = reveals[i].offsetHeight;
      var elementVisible = containerHeight - 300;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", reveal);

  // Initial calculation of container heights
  var containers = document.querySelectorAll(".reveal");
  for (var i = 0; i < containers.length; i++) {
    containers[i].addEventListener("load", function() {
      reveal();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
